import { render, staticRenderFns } from "./DeptList.vue?vue&type=template&id=43c1e513&scoped=true"
import script from "./DeptList.vue?vue&type=script&lang=js"
export * from "./DeptList.vue?vue&type=script&lang=js"
import style0 from "./DeptList.vue?vue&type=style&index=0&id=43c1e513&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c1e513",
  null
  
)

export default component.exports